import { styled } from 'parkdepot-shared/theme'

export const Container = styled<'div', { $noPadding?: boolean }>('div', ({ $noPadding = false, $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: $noPadding ? 0 : '2.4rem 1.6rem',
    gap: '2rem',
    backgroundColor: $theme.colors.white,

    [$theme.mediaQuery.large]: {
        borderRadius: '24px',
        padding: $noPadding ? 0 : '2.4rem'
    }
}))

export const InputContainer = styled<'input', { $empty?: boolean }>('input', ({ $theme, $empty = true }) => ({
    ...$theme.typography.ParagraphMedium,
    height: '5rem',
    padding: '1.2rem 2rem',
    width: '100%',
    border: '1px solid #B3BBC7',
    outline: 'none',
    borderRadius: '2.4rem',
    fontSize: '1.6rem',
    color: $empty ? '#B3BBC7' : '#000',
    fontWeight: 300,
    lineHeight: '2.4rem',

    // placeholder
    '::placeholder': {
        color: '#B3BBC7',
        fontWeight: 300,
        fontSize: '1.6rem'
    }
}))

export const InputPlaceholder = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphXSmall,
    fontWeight: 300,
    marginBottom: '4px',
    color: '#667085'
}))

export const TitleContainer = styled('div', () => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    position: 'relative'
}))

export const Title = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphLarge,
    fontWeight: 600
}))

export const ValueLabel = styled('span', () => ({
    color: '#1F1F1F',
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
}))

export const OptionIcon = styled('i', () => ({
    fontSize: '1.6rem'
}))

export const OptionText = styled('span', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium
}))

export const SelectDownArrow = styled('i', () => ({
    fontSize: '1.4rem',
    cursor: 'pointer'
}))

export const PlateError = styled('div', () => ({
    color: '#FF0000',
    fontSize: '1.6rem',
    marginTop: '0.8rem'
}))

export const ButtonContainer = styled('div', ({ $theme }) => ({
    marginTop: '1rem',
    display: 'flex',
    gap: '1.6rem',
    flexDirection: 'column'
}))

export const ModalBodyContent = styled('div', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    padding: '0 1.6rem',

    [$theme.mediaQuery.large]: {
        ...$theme.typography.ParagraphMedium,
        textAlign: 'center'
    }
}))

export const SubmitButtonContainer = styled('div', () => ({
    padding: '0 1.6rem 3.2rem'
}))

export const Label = styled('label', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    fontWeight: 600
}))

export const SelectOverrides = {
    Root: {
        style: {
            border: '1px solid #ccc',
            borderRadius: '2.4rem',
            paddingLeft: '0.6rem'
        }
    },
    ControlContainer: {
        // sometimes baseui bugs it out here and shows multiple borders, this should do the trick for now
        style: {
            backgroundColor: '#fff',
            border: '1px solid transparent',
            borderLeftColor: 'transparent !important',
            borderRightColor: 'transparent !important',
            borderTopColor: 'transparent !important',
            borderBottomColor: 'transparent !important'
        }
    },
    DropdownListItem: {
        style: {
            ':hover': {
                backgroundColor: '#EFF3FE'
            }
        }
    },
    Input: {
        style: {}
    },
    Placeholder: {
        style: {
            fontSize: '1.6rem',
            lineHeight: '2.4rem',
            color: '#B3BBC7',
            fontWeight: 300
        }
    },
    DropdownContainer: {
        style: {
            // weird baseweb behaviour because of the borders.
            // otherwise the dropdown is not aligned with the input
            marginLeft: '3px'
        }
    },
    Popover: {
        props: {
            overrides: {
                Body: {
                    style: {
                        zIndex: 9999
                    }
                }
            }
        }
    }
}

export const BaseButtonOverrides = {
    BaseButton: {
        style: {
            width: '100%',
            color: '#FE2C3E',
            fontWeight: 600,
            borderColor: '#FE2C3E',

            ':hover': {
                borderColor: '#FE2C3E',
                backgroundColor: '#FE2C3E',
                color: 'white'
            },

            ':focus': {
                borderColor: '#FE2C3E',
                backgroundColor: '#FE2C3E',
                color: 'white'
            }
        }
    }
}
